import React, { useEffect, useLayoutEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import classNames from "classnames";

// Context
import { useAuth } from "./context/useAuth";
import Sidebar from "./components/common/Sidebar";

// Pages
import Login from "./pages/Login";
import UserList from "./pages/UserList";
import RoleManagement from "./pages/RoleManagement";
import { Tooltip } from "react-tooltip";

export default function RoutesApp() {
  let auth = useAuth();
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(true);

  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    auth.checkAuth();
  }, []);

  return (
    <div className={"main-wrapper" + (auth.user ? " logged" : " hide-sidebar") + (sidebarVisible ? "" : " hide-sidebar")}>
      <Sidebar sidebarVisible={sidebarVisible} />
      <div className="page-container">
        <Routes>
          {auth.user ? (
            <>
              {auth.checkPrivileges("editUser") && <Route path="/" element={<UserList />} />}
              {auth.checkPrivileges("editUser") && <Route path="/user" element={<UserList />} />}
              {auth.checkPrivileges("editRoles") && <Route path="/settings/roles" element={<RoleManagement />} />}
            </>
          ) : (
            <Route path="*" element={<Login />} />
          )}
        </Routes>
      </div>
      {auth.user && (
        <button
          className={classNames("btn-sidebar-toggle-fixed", sidebarVisible ? "sidebar-open" : "sidebar-closed")}
          onClick={() => setSidebarVisible((prev) => !prev)}
          aria-label={sidebarVisible ? "Hide sidebar" : "Show sidebar"}
        >
          <i className="material-icons">{sidebarVisible ? "chevron_left" : "chevron_right"}</i>
        </button>
      )}
      <Tooltip id="my-tooltip" />
    </div>
  );
}
